import { PageToolbar } from '@app/components/page-toolbar/PageToolbar';
import { LiveTopicsCategoryFilter } from './LiveTopicsCategoryFilter';

export interface LiveTopicsPanelCategoryToolbarProps {
  categoryOptions: string[];
  selectedCategories: string[];
  onSelectedCategoriesChange: (value: string[]) => void;
}

/**
 * Toolbar strip for the Live Topics panel list view: category multi-select (Autocomplete
 * with chips inside input and built-in reset).
 */
export function LiveTopicsPanelCategoryToolbar({
  categoryOptions,
  selectedCategories,
  onSelectedCategoriesChange,
}: LiveTopicsPanelCategoryToolbarProps) {
  return (
    <PageToolbar
      sx={{
        px: 1.5,
        pt: 2,
      }}
    >
      <LiveTopicsCategoryFilter
        options={categoryOptions}
        value={selectedCategories}
        onChange={onSelectedCategoriesChange}
      />
    </PageToolbar>
  );
}
